<template>
    <div class="tab-content p-0">
        <div class="tab-pane fade active show" id="profile-post">
            <ul class="timeline">
                <li v-for="(post, index) in postList" :key="index">
                    <div class="timeline-body">
                        <div class="timeline-header">
                            <span class="userimage">{{ filterName(getName(post.author.$oid)) }}</span>
                            <div class="span-group">
                                <span class="username"><a href="javascript:;">{{ getName(post.author.$oid) }}</a> <small></small></span>
                                <span class="post-date">{{ getTime(post.add_date) }}</span>
                            </div>
                            <div v-show="checkTags(post.related_tags)" class="related-group"> >
                                <a href="javascript:;" class="related-tag pl-1" v-for="(tag, key, index) in post.related_tags" v-bind:key='index' @click="openCard(tag)"> {{ tag.name }}
                                    <p v-if="index != Object.keys(post.related_tags).length-1">,</p>
                                </a>
                                <span class="pl-1">hakkında</span>
                            </div>
                            
                            <!-- <span class="pull-right text-muted">18 Views</span> -->
                        </div>
                        <div class="timeline-content">
                            <p>{{ post.content }}</p>
                        </div>
                        <!-- <div class="timeline-likes">
                            <div class="stats-right">
                                <span class="stats-text">259 Shares</span>
                                <span class="stats-text">21 Comments</span>
                            </div>
                            <div class="stats">
                                <span class="fa-stack fa-fw stats-icon">
                                <i class="fa fa-circle fa-stack-2x text-danger"></i>
                                <i class="fa fa-heart fa-stack-1x fa-inverse t-plus-1"></i>
                                </span>
                                <span class="fa-stack fa-fw stats-icon">
                                <i class="fa fa-circle fa-stack-2x text-primary"></i>
                                <i class="fa fa-thumbs-up fa-stack-1x fa-inverse"></i>
                                </span>
                                <span class="stats-total">4.3k</span>
                            </div>
                        </div> -->
                        <div class="timeline-footer">
                            <a href="javascript:;" class="m-r-15 text-inverse-lighter mr-2" @click="addLike(post)"><i class="fa fa-thumbs-up fa-fw fa-lg m-r-3" :class="checkLike(post.likes)"></i><span :class="checkLike(post.likes)">Beğen ({{ post.likes.length }})</span></a>
                            <a href="javascript:;" class="m-r-15 text-inverse-lighter" @click="displayComment(post._id.$oid)"><i class="fa fa-comments fa-fw fa-lg m-r-3"></i>Yorum ({{ Object.keys(post.comments).length }})</a> 
                        </div>
                        <div class="timeline-comment-box" v-if="showComment">
                            <div v-if="commentsConfig[post._id.$oid]">
                                <div v-for="(comment, index) of sortedItems(post.comments).reverse()" :key="index" >
                                    <div class="timeline-header">
                                        <span class="user" >{{ filterName(getName(comment.userId.$oid)) }}</span>
                                        <div class="span-group pl-2">
                                            <span class="username"><a href="javascript:;">{{ getName(comment.userId.$oid) }}</a> <small></small></span>
                                            <span class="post-date">{{ getTime(comment.comment_date) }}</span>
                                        </div>
                                    </div>
                                    <div class="timeline-content mt-2">
                                        <p>{{ comment.text }}</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="user">{{filterName(userName)}}</div>
                            <div class="input">
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="Write a comment..." v-model="comments[post._id.$oid]">
                                    <span class="input-group-btn p-l-10">
                                        <button class="btn btn-primary f-s-12 rounded-corner" type="button" @click="addCommentF(post._id.$oid)">Gönder</button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { mapGetters, mapState, mapActions } from 'vuex'
    import moment from 'moment'
    import {v4 as uuidv4} from 'uuid';

    export default {
        name: "Posts",

        data () {
            return {
                postList: [],
                comments: {},
                commentsConfig: {},
                showComment: true
            }
        },

        computed:{
            ...mapState([
                'baseUrl'
            ]),
            ...mapGetters(['userName', 'users']),
        },

        created() {
            this.$root.$refs.posts = this
        },

        methods: {
            ...mapActions([
                'updateDealId',
                'updateOrgId',
                'updateContactId',
            ]),
            openCard(obj) {
                // console.log(obj);
                // var type = "" 
                // if(obj.type = 'organizations'){
                //     console.log("ilk if");
                //     localStorage.orgId = obj._id.$oid
                //     this.updateOrgId(obj._id.$oid)
                //     type = "/organizationCard/"
                // }
                // else if(obj.type = 'contacts'){
                //     console.log("ikinci if");
                //     localStorage.contactId = obj._id.$oid
                //     this.updateContactId(obj._id.$oid)
                //     type = "/contactCard/"
                // }
                // else if(obj.type = 'deals'){
                //     console.log("son if");
                //     localStorage.dealId = obj._id.$oid
                //     this.updateDealId(obj._id.$oid)
                //     type = "/dealCard/"
                // }
                
                // window.open(type + obj._id.$oid, '_blank');
            },
            checkTags(tags){
                var check = false
                if(tags == null || tags == undefined) return check
                
                if(typeof tags === "object" && Object.keys(tags).length > 0) {
                    check = true
                }
                return check
            },
            checkLike(likes){
                var check = false
                if(likes.includes(localStorage.cuid)){
                    check = true
                }
                return {
                    colorBlue: check == true
                }
            },
            getName(author){
                var n, sn = ""
                for( let user of this.users){
                    if(user._id.$oid == author) {
                        n = user.name 
                        sn = user.surName
                    }
                }
                if(sn == undefined) {
                    return n
                }

                return n + " " + sn
            },
            getTime(date){
                var time = moment(date.$date).format("HH:mm")
                var timeDiff = moment(date.$date).fromNow()
                
                if(timeDiff.includes("dakika") || timeDiff.includes("saniye")){
                    return timeDiff
                }
                if(timeDiff.includes("saat")){
                    return "Bugün " + time 
                }
                if(timeDiff == "bir gün önce"){
                    return "Dün " + time
                }
                // if(timeDiff.includes("yıl")){
                //     return moment(date.$date,"YYYY-MM-DDTHH:mm:ss.SSSSZ", true).format('LLL')
                // }

                return moment(date.$date,"YYYY-MM-DDTHH:mm:ss.SSSSZ", true).format('LLL')
            },
            sortedItems(comments){
                let array = []

                for(let key in comments) {
                    array.push(comments[key])
                }

                if(array.length > 0){
                    var sortedArray = array.sort(function (a, b) {
                        var dateA = new Date(a.comment_date.$date), dateB = new Date(b.comment_date.$date)
                        return dateA - dateB
                    });

                    return sortedArray
                }
                else{
                    return comments
                }
            },
            custom_sort(a, b) {
                return new Date(a.comment_date.$date).getTime() - new Date(b.comment_date.$date).getTime();
            },
            displayComment(id){
                if(this.commentsConfig[id]){
                    this.commentsConfig[id] = !this.commentsConfig[id]
                }
                else{
                    this.commentsConfig[id] = true
                }
                this.showComment = false
                this.showComment = true
            },
            addLike(post){
                var params = {}
                var likesArr = post.likes
                
                if(likesArr.includes(localStorage.cuid)){
                    likesArr.pop(localStorage.cuid)
                }
                else{
                    likesArr.push(localStorage.cuid)
                }
                
                params.post_id = post._id.$oid
                params.author = post.author.$oid
                params.content = post.content
                params.related_tags = post.related_tags
                params.likes = likesArr
                params.isActive = true
                params.comments = post.comments

                axios({
                    method:'POST',
                    url:'/updatePost',
                    baseURL: this.baseUrl,
                    data: params,
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            this.getPostsF()
                        }
                    }else{
                        
                    }
                })
            },
            addCommentF(postId){

                if(this.comments[postId] == "" || this.comments[postId] == null || this.comments[postId] == undefined ) {
                    alert("Yorum alanı boş olamaz!")
                }
                
                var params = {}
                params.post_id = postId
                params.comment = this.comments[postId]
                
                axios({
                    method:'POST',
                    url:'/addComment',
                    baseURL: this.baseUrl,
                    data: params,
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            this.getPostsF()
                            this.comments = {}
                        }
                    }else{
                        
                    }
                })
            },
            getPostsF(){
                var params = {}
                params.pagingSize = 30
                params.pagingOffset = 0

                axios({
                    method:'POST',
                    url:'/getPosts',
                    baseURL: this.baseUrl,
                    data: params,
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            if(res.data.content.posts){
                                this.postList = res.data.content.posts.reverse()
                            }
                        }
                    }else{
                        
                    }
                })
            },
            filterName:function(value){
                if (!value) return '';
                const firstLetters = value.split(/\s+/).map((word) => { return word && word[0] ? word[0].toUpperCase() : ''; }).join("");
                return firstLetters;
            },
        },

        mounted() {
            this.getPostsF()
            
        }
    }
</script>

<style>
    .rounded-corner {
        background: #1999EB;
        border: none;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        height: 38px;
    }
    .colorBlue{
        color: #00408A;
    }
    .form-control {
        border: none;
    }

    .related-group {
        display: inline-flex;
    }

    .related-tag{
        display: flex;
        color: #00408A;
        max-height: 16px;
    }

    .span-group {
        display: inline-flex;
        flex-direction: column;
        margin-right: 2px;
    }

    .post-date {
        font-size: 12px;
        font-weight: 400;
        color: rgba(68, 68, 68, 0.6);
    }

    .timeline {
        list-style-type: none;
        margin: 0;
        padding: 0;
        position: relative;
    }

    .timeline>li {
        position: relative;
        min-height: 50px;
        padding: 16px 0 0 0
    }

    .timeline .timeline-time {
        position: absolute;
        left: 0;
        width: 18%;
        text-align: right;
        top: 30px
    }

    .timeline .timeline-time .date,
    .timeline .timeline-time .time {
        display: block;
        font-weight: 600
    }

    .timeline .timeline-time .date {
        line-height: 16px;
        font-size: 12px
    }

    .timeline .timeline-time .time {
        line-height: 24px;
        font-size: 20px;
        color: #242a30
    }

    .timeline .timeline-icon {
        left: 15%;
        position: absolute;
        width: 10%;
        text-align: center;
        top: 40px
    }

    .timeline .timeline-icon a {
        text-decoration: none;
        width: 20px;
        height: 20px;
        display: inline-block;
        border-radius: 20px;
        background: #d9e0e7;
        line-height: 10px;
        color: #fff;
        font-size: 14px;
        border: 5px solid #2d353c;
        transition: border-color .2s linear
    }

    .timeline .timeline-body {
        /* margin-left: 23%;
        margin-right: 17%; */
        background: #fff;
        position: relative;
        padding: 16px 18px;
        border-radius: 8px
    }

    /* .timeline .timeline-body:before {
        content: '';
        display: block;
        position: absolute;
        border: 10px solid transparent;
        border-right-color: #fff;
        left: -20px;
        top: 20px
    } */

    .timeline .timeline-body>div+div {
        margin-top: 15px
    }

    .timeline .timeline-body>div+div:last-child {
        margin-bottom: -20px;
        padding-bottom: 20px;
        border-radius: 0 0 8px 8px
    }

    .timeline-header {
        padding-bottom: 5px;
        line-height: 16px
    }

    .timeline-header .userimage {
        display: flex;
        justify-content: center;
        align-items: center;
        float: left;
        width: 40px;
        height: 40px;
        border-radius: 40px;
        overflow: hidden;
        margin: -4px 8px -4px 0;
        background-color: rgb(230, 230, 230);
        color: #3767A0;
        font-size: 15px;
    }

    .timeline-header .username {
        font-size: 14px;
        font-weight: 600;
    }

    .timeline-header .username,
    .timeline-header .username a {
        color: #00408A
    }

    .timeline img {
        max-width: 100%;
        display: block
    }

    .timeline-content {
        letter-spacing: .25px;
        line-height: 18px;
        font-size: 14px
    }

    .timeline-content:after,
    .timeline-content:before {
        content: '';
        display: table;
        clear: both
    }

    .timeline-title {
        margin-top: 0
    }

    .timeline-footer {
        background: #fff;
        border-top: 1px solid #e2e7ec;
        padding-top: 15px
    }

    .timeline-footer a:not(.btn) {
        color: #575d63
    }

    .timeline-footer a:not(.btn):focus,
    .timeline-footer a:not(.btn):hover {
        color: #2d353c
    }

    .timeline-likes {
        color: #6d767f;
        font-weight: 600;
        font-size: 12px
    }

    .timeline-likes .stats-right {
        float: right
    }

    .timeline-likes .stats-total {
        display: inline-block;
        line-height: 20px
    }

    .timeline-likes .stats-icon {
        float: left;
        margin-right: 5px;
        font-size: 9px
    }

    .timeline-likes .stats-icon+.stats-icon {
        margin-left: -2px
    }

    .timeline-likes .stats-text {
        line-height: 20px
    }

    .timeline-likes .stats-text+.stats-text {
        margin-left: 15px
    }

    .timeline-comment-box {
        background: #EBEBEB;
        margin-left: -18px;
        margin-right: -18px;
        padding: 16px 18px;
    }

    .timeline-comment-box .user {
        display: flex;
        justify-content: center;
        align-items: center;
        float: left;
        width: 34px;
        height: 34px;
        overflow: hidden;
        border-radius: 30px;
        background-color: rgb(255, 255, 255);
        color: #3767A0;
        font-size: 12px;
    }

    .timeline-comment-box .user img {
        max-width: 100%;
        max-height: 100%
    }

    .timeline-comment-box .user+.input {
        margin-left: 44px
    }

    .timeline-comment-box .timeline-content {
        border-bottom: 1px solid #D2D1D1;
        margin: 16px 0;
    }

    .lead {
        margin-bottom: 20px;
        font-size: 21px;
        font-weight: 300;
        line-height: 1.4;
    }

    .text-danger, .text-red {
        color: #ff5b57!important;
    }
</style>